module.exports = __webpack_public_path__ + "static/img/addleshaw.f4dc536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/home-page-logos/addleshaw.png
// module id = IV10
// module chunks = 0